import { render, staticRenderFns } from "./SelectorTipoDocumento.vue?vue&type=template&id=ef059cb6&scoped=true&lang=pug"
import script from "./SelectorTipoDocumento.vue?vue&type=script&lang=js"
export * from "./SelectorTipoDocumento.vue?vue&type=script&lang=js"
import style0 from "./SelectorTipoDocumento.vue?vue&type=style&index=0&id=ef059cb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef059cb6",
  null
  
)

export default component.exports